import React, { createContext, useContext, useEffect, useState } from "react";
import ReactGA from "react-ga4";

import { Box, Button, Flex, Text } from "@chakra-ui/react";

type ConsentContextType = {
  hasConsent: boolean;
  setConsent: (accepted: boolean) => void;
};

const ConsentContext = createContext<ConsentContextType>({
  hasConsent: false,
  setConsent: (_accepted: boolean) => {},
});

export const useConsent = () => useContext(ConsentContext);

export default function ConsentContextBanner({
  children,
}: React.PropsWithChildren) {
  const gaId = "G-W9KHLM3GHE";
  const [hasConsent, setHasConsent] = useState(() => {
    return localStorage.getItem("tracking-consent") === "true";
  });
  const [decisionMade, setDecisionMade] = useState(() => {
    const stored = localStorage.getItem("tracking-consent");
    return stored === "true" || stored === "false";
  });

  useEffect(() => {
    if (gaId && hasConsent) {
      ReactGA.initialize(gaId);
      ReactGA.send({ hitType: "pageview", page: window.location.hash });
    }
  }, [hasConsent, gaId]);

  const handleConsent = (accepted: boolean) => {
    localStorage.setItem("tracking-consent", accepted ? "true" : "false");
    setHasConsent(accepted);
    setDecisionMade(true);
  };

  return (
    <ConsentContext.Provider value={{ hasConsent, setConsent: handleConsent }}>
      {!decisionMade && (
        <Box
          position="fixed"
          bottom="0"
          left="0"
          right="0"
          width="100%"
          bg="gray.700"
          color="white"
          px={6}
          py={4}
          zIndex={9999}
          boxShadow="lg"
        >
          <Flex
            direction={{ base: "column", sm: "row" }}
            align="center"
            justify="space-between"
            gap={4}
            maxW="7xl"
            mx="auto"
            flexWrap="wrap"
          >
            <Text
              fontSize="sm"
              maxW="45ch"
              textAlign={{ base: "center", sm: "left" }}
            >
              Wir verwenden Cookies, um anonymisierte Nutzungsstatistiken mit
              Google Analytics zu sammeln. Bitte wähle, ob du das erlauben
              möchtest.
            </Text>
            <Flex
              gap={3}
              wrap="wrap"
              justify={{ base: "center", sm: "flex-start" }}
            >
              <Button colorScheme="green" onClick={() => handleConsent(true)}>
                Akzeptieren
              </Button>
              <Button colorScheme="red" onClick={() => handleConsent(false)}>
                Ablehnen
              </Button>
            </Flex>
          </Flex>
        </Box>
      )}
      {children}
    </ConsentContext.Provider>
  );
}
